import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Input,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
} from '@chakra-ui/react';
import axiosInstance from '../../../api/AxiosInstance';

const Movimientos: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [filters, setFilters] = useState<any>({
    entidad: '',
    entidadId: '',
    fechaInicio: '',
    fechaFin: '',
  });

  const handleChange = (field: string, value: any) => {
    setFilters((prev: any) => ({ ...prev, [field]: value }));
  };

  const fetchData = async () => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (v) params.append(k, String(v));
    });
    const res = await axiosInstance.get(`/desarrollo-social/movimientos?${params.toString()}`);
    setData(res.data || []);
  };

  useEffect(() => { fetchData(); }, []);

  return (
    <VStack spacing={6} align="stretch" px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <Box bg="white" p={4} borderRadius="md" boxShadow="sm">
        <Flex gap={3} flexWrap="wrap" align="center">
          <Input placeholder="Entidad" value={filters.entidad} onChange={(e) => handleChange('entidad', e.target.value)} w="140px" />
          <Input placeholder="Entidad ID" value={filters.entidadId} onChange={(e) => handleChange('entidadId', e.target.value)} w="140px" />
          <Input type="date" value={filters.fechaInicio} onChange={(e) => handleChange('fechaInicio', e.target.value)} w="170px" />
          <Input type="date" value={filters.fechaFin} onChange={(e) => handleChange('fechaFin', e.target.value)} w="170px" />
          <Button size="sm" onClick={fetchData} variant="outline">Aplicar</Button>
        </Flex>
      </Box>

      <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white">
        <Table size="sm">
          <Thead bg="#5b182b">
            <Tr>
              <Th color="white" fontSize="xs">Fecha</Th>
              <Th color="white" fontSize="xs">Entidad</Th>
              <Th color="white" fontSize="xs">Entidad ID</Th>
              <Th color="white" fontSize="xs">Accion</Th>
              <Th color="white" fontSize="xs">Usuario</Th>
            </Tr>
          </Thead>
          <Tbody>
            {data.length === 0 ? (
              <Tr><Td colSpan={5} textAlign="center" py={6}><Text color="gray.400">Sin movimientos</Text></Td></Tr>
            ) : data.map((item) => (
              <Tr key={item.id}>
                <Td>{item.fecha ? new Date(item.fecha).toLocaleString('es-MX') : '-'}</Td>
                <Td>{item.entidad}</Td>
                <Td>{item.entidadId}</Td>
                <Td>{item.accion}</Td>
                <Td>{item.usuarioId || '-'}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </VStack>
  );
};

export default Movimientos;

